const urlBaseApi = {
  urlAssets: 'http://localhost:5000/images/'
}

export default urlBaseApi;